const actorIsHeadBoxStaff = (searchParams: URLSearchParams): boolean => {
  const staffParam = searchParams.get('headBoxStaff')

  // anticipate variations of 'false' as the value of the param
  return !!staffParam && staffParam[0].toLowerCase() !== 'f'
}

export default actorIsHeadBoxStaff
